import React from 'react';
import { useParams } from 'react-router-dom';
import { Stack, Text } from '@moda/om';
import { US_RETURN_OPTIONS_FEDEX, INTERNATIONAL_RETURN_OPTIONS } from '../../constants';
import { useReturnSummary } from '../../hooks/useReturnSummary';

import './ReturnInformation.scss';

export enum ReturnMethod {
  OriginalPaymentMethod = 0,
  SiteCredit = 1
}

export const ReturnInformation: React.FC = () => {
  const { shipmentNumber } = useParams<{ shipmentNumber: string }>();
  const { returnSummary } = useReturnSummary({ shipmentNumber });

  if (!returnSummary) return null;

  const options =
    returnSummary.attributes.countryCode === 'US'
      ? US_RETURN_OPTIONS_FEDEX
      : INTERNATIONAL_RETURN_OPTIONS;

  const returnOption = options.find((option: { value: number }) => {
    return returnSummary.attributes.returnOptionId === option.value;
  });

  return (
    <Stack space={3}>
      <Stack space={2}>
        <Text className="ReturnInformation__title" treatment="h5">
          Refund Method
        </Text>

        {returnSummary.attributes.returnMethodId === ReturnMethod.OriginalPaymentMethod && (
          <Stack space={0}>
            <Text color="cement">Original Payment Method</Text>
            <Text color="cement">Refund will be issued to your original method of payment(s).</Text>
          </Stack>
        )}

        {returnSummary.attributes.returnMethodId === ReturnMethod.SiteCredit && (
          <Text color="cement">Site Credit</Text>
        )}
      </Stack>

      <Stack space={2}>
        <Text className="ReturnInformation__title" treatment="h5">
          Return Options
        </Text>

        {returnOption && (
          <Stack space={0}>
            <Text color="cement">{returnOption.label} </Text>
            <Text color="cement">{returnOption.description[0]} </Text>
          </Stack>
        )}
      </Stack>
    </Stack>
  );
};
